var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverDraftLimit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M3189.662,2402.914c-79.97,307.485-305.157,592.273-850.634,739.614 c-197.115,53.268-426.514,79.421-631.024,63.263c-300.982-23.793-616.443-159.665-867.134-313.716 c-173.494-106.603-242.542-250.452-266.986-413.06c-15.131-100.543-13.214-208.242-8.388-318.748 c7.258-166.238-19.171-333.639-58.299-495.392c-60.216-249.048-10.613-510.284,137.96-724.516 c148.573-214.233,383.346-363.286,651.121-413.369c451.128-84.352,908.794-28.688,908.794-28.688 c602.782,62.613,907.905,661.048,982.329,1148.156C3221.43,1869.077,3256.999,2144.041,3189.662,2402.914z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M1707.656,1336.415c0.494,0,0.977-0.831,1.448-0.831h1.241c7.485,0,15.1-3.243,21.442-10.635 c8.847-10.313,13.132-24.171,11.184-36.836c-0.624-4.057-4.423-6.643-8.479-6.009c-4.058,0.624-6.842,4.523-6.218,8.582 c1.287,8.368-1.764,19.826-7.773,26.829c-3.321,3.871-7.212,7.8-10.156,7.8h-1.273c-7.922,0-18.759-1.429-24.544-7.201 c-3.259-3.253-4.912-9.23-4.912-16.319c0-24.206,32.338-37.419,32.665-37.545c2.815-1.093,4.702-3.971,4.754-6.991l0.743-43.66 c0.071-4.105-3.2-8.1-7.305-8.1c-0.044,0-0.088,0-0.131,0c-4.046,0-7.36,3.691-7.43,7.753l-0.662,38.61 c-11.036,5.358-37.503,21.225-37.503,49.085c0,11.181,3.122,19.608,9.279,25.75 C1683.694,1336.343,1697.764,1336.415,1707.656,1336.415z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A8793"
    },
    d: "M1728.921,1100.324c-4.106,0-6.847-3.328-6.847-7.435V814.837c0-4.107,2.741-7.435,6.847-7.435 s6.847,3.328,6.847,7.435v278.053C1735.768,1096.996,1733.027,1100.324,1728.921,1100.324z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2484.488,812.608c-0.847,0-1.708-0.145-2.55-0.453c-3.857-1.409-5.842-5.676-4.433-9.534 l125.179-342.737c1.105-3.025,4.07-4.96,7.249-4.879c3.218,0.115,5.996,2.288,6.882,5.384l98.131,342.736 c1.13,3.947-1.153,8.063-5.1,9.193c-3.948,1.128-8.064-1.153-9.194-5.101l-91.841-320.765l-117.338,321.271 C2490.371,810.738,2487.522,812.608,2484.488,812.608z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2603.585,908.512c-4.106,0-8.558-3.328-8.558-7.435V474.334c0-4.106,4.453-7.435,8.558-7.435 s8.558,3.328,8.558,7.435v426.744C2612.144,905.184,2607.691,908.512,2603.585,908.512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2576.771,
    y: 1017.471,
    transform: "matrix(0.669 -0.7433 0.7433 0.669 9.9686 2297.3772)",
    style: {
      fill: "#D8DEE8"
    },
    width: 14.87,
    height: 240.052
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2464.18,
    y: 1130.062,
    transform: "matrix(0.7433 -0.6689 0.6689 0.7433 -97.6171 2020.5853)",
    style: {
      fill: "#D8DEE8"
    },
    width: 240.052,
    height: 14.87
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2576.771,
    y: 1182.518,
    transform: "matrix(0.669 -0.7433 0.7433 0.669 -112.7102 2352.0137)",
    style: {
      fill: "#D8DEE8"
    },
    width: 14.87,
    height: 240.052
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2464.18,
    y: 1295.11,
    transform: "matrix(0.7433 -0.6689 0.6689 0.7433 -208.0207 2062.9475)",
    style: {
      fill: "#D8DEE8"
    },
    width: 240.052,
    height: 14.87
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2581.232,
    y: 1346.079,
    transform: "matrix(0.669 -0.7433 0.7433 0.669 -232.8071 2409.4736)",
    style: {
      fill: "#D8DEE8"
    },
    width: 14.87,
    height: 240.052
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2468.641,
    y: 1458.67,
    transform: "matrix(0.7433 -0.6689 0.6689 0.7433 -316.2816 2107.9263)",
    style: {
      fill: "#D8DEE8"
    },
    width: 240.052,
    height: 14.87
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2581.232,
    y: 1517.074,
    transform: "matrix(0.669 -0.7433 0.7433 0.669 -359.9067 2466.0791)",
    style: {
      fill: "#D8DEE8"
    },
    width: 14.87,
    height: 240.052
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2468.641,
    y: 1629.665,
    transform: "matrix(0.7433 -0.6689 0.6689 0.7433 -430.6642 2151.8154)",
    style: {
      fill: "#D8DEE8"
    },
    width: 240.052,
    height: 14.87
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2581.232,
    y: 1689.556,
    transform: "matrix(0.669 -0.7433 0.7433 0.669 -488.1115 2523.1768)",
    style: {
      fill: "#D8DEE8"
    },
    width: 14.87,
    height: 240.052
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2468.641,
    y: 1802.147,
    transform: "matrix(0.7433 -0.6689 0.6689 0.7433 -546.0416 2196.0862)",
    style: {
      fill: "#D8DEE8"
    },
    width: 240.052,
    height: 14.87
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2581.232,
    y: 1854.603,
    transform: "matrix(0.669 -0.7433 0.7433 0.669 -610.7905 2577.8123)",
    style: {
      fill: "#D8DEE8"
    },
    width: 14.87,
    height: 240.053
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2468.641,
    y: 1967.194,
    transform: "matrix(0.7433 -0.6689 0.6689 0.7433 -656.4458 2238.449)",
    style: {
      fill: "#D8DEE8"
    },
    width: 240.053,
    height: 14.87
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2488.903,
    y: 1044.6,
    style: {
      fill: "#D8DEE8"
    },
    width: 13.693,
    height: 1023.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2673.764,
    y: 1044.6,
    style: {
      fill: "#D8DEE8"
    },
    width: 20.54,
    height: 1023.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2495.75,
    y: 1208.92,
    style: {
      fill: "#D8DEE8"
    },
    width: 184.861,
    height: 17.117
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2495.75,
    y: 1376.664,
    style: {
      fill: "#D8DEE8"
    },
    width: 184.861,
    height: 20.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2495.75,
    y: 1547.831,
    style: {
      fill: "#D8DEE8"
    },
    width: 184.861,
    height: 13.693
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2495.75,
    y: 1715.575,
    style: {
      fill: "#D8DEE8"
    },
    width: 184.861,
    height: 13.693
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2495.75,
    y: 1883.319,
    style: {
      fill: "#D8DEE8"
    },
    width: 184.861,
    height: 17.117
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2576.771,
    y: 1017.471,
    transform: "matrix(0.669 -0.7433 0.7433 0.669 9.9686 2297.3772)",
    style: {
      fill: "#D8DEE8"
    },
    width: 14.87,
    height: 240.052
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M2478.633,791.272v269.277c0,8.828-0.276,11.437,8.552,11.437h214.859 c8.828,0,16.223-2.609,16.223-11.437V791.272H2478.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#E6EBF4"
    },
    d: "M2673.764,927.48c0,9.854-7.989,17.843-17.843,17.843h-135.481 c-9.854,0-17.843-7.989-17.843-17.843v-63.591c0-9.854,7.989-17.843,17.843-17.843h135.481c9.854,0,17.843,7.989,17.843,17.843 V927.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2607.582,678.784c-1.57,0-3.142-0.542-4.443-1.629l-56.902-47.581 c-3.067-2.564-3.565-7.243-1.111-10.449c2.454-3.206,6.929-3.726,9.997-1.162l52.293,43.726l45.003-40.488 c2.979-2.68,7.469-2.328,10.031,0.784c2.563,3.112,2.226,7.806-0.751,10.484l-49.477,44.514 C2610.891,678.182,2609.238,678.784,2607.582,678.784z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2605.023,767.999c-0.948,0-1.893-0.181-2.784-0.54l-90.845-36.682 c-3.807-1.538-5.648-5.871-4.11-9.678c1.537-3.807,5.869-5.644,9.677-4.111l88.393,35.693l80.166-24.759 c3.929-1.208,8.086,0.986,9.298,4.909c1.212,3.923-0.987,8.086-4.909,9.297l-82.692,25.539 C2606.501,767.889,2605.761,767.999,2605.023,767.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A8793"
    },
    d: "M1686.129,1100.324c-4.107,0-8.558-3.328-8.558-7.435V805.172c0-3.109,2.487-5.889,5.402-6.97 l924.227-342.736c2.357-0.877,5.138-0.5,7.156,1.002l432.446,321.176c3.296,2.448,4.018,7.105,1.57,10.401 c-2.448,3.298-7.088,3.986-10.384,1.535l-428.56-318.772l-914.74,339.536v282.545 C1694.687,1096.996,1690.235,1100.324,1686.129,1100.324z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M3094.835,796.987c0-8.828-7.156-15.984-15.984-15.984H1659.322 c-8.828,0-15.984,7.156-15.984,15.984v5.688c0,8.828,7.156,15.984,15.984,15.984h1419.529c8.828,0,15.984-7.156,15.984-15.984 V796.987z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2916.821,
    y: 825.506,
    style: {
      fill: "#97A6B7"
    },
    width: 160.897,
    height: 205.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2923.668,
    y: 839.199,
    style: {
      opacity: 0.5,
      fill: "#E6EBF4"
    },
    width: 23.963,
    height: 160.897
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2968.171,
    y: 839.199,
    style: {
      opacity: 0.5,
      fill: "#E6EBF4"
    },
    width: 23.963,
    height: 160.897
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3002.405,
    y: 839.199,
    style: {
      opacity: 0.5,
      fill: "#E6EBF4"
    },
    width: 23.963,
    height: 160.897
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3036.638,
    y: 839.199,
    style: {
      opacity: 0.5,
      fill: "#E6EBF4"
    },
    width: 30.81,
    height: 160.897
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M1746.578,1068.563h-68.893c-4.38,0-6.961,2.599-6.961,6.979v91.594 c0,3.481,0.384,6.905,2.042,9.964l25.949,48.936c0.934,1.721,2.492,3.424,4.45,3.424h19.598c1.994,0,3.822-1.742,4.739-3.513 l25.563-47.926c1.54-2.972,3.243-6.585,3.243-9.931v-92.547C1756.308,1071.162,1750.958,1068.563,1746.578,1068.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#E6EBF4"
    },
    d: "M1739.191,1139.727c0,9.854-7.989,17.843-17.843,17.843h-22.511 c-9.854,0-17.843-7.989-17.843-17.843v-36.204c0-9.854,7.988-17.843,17.843-17.843h22.511c9.854,0,17.843,7.989,17.843,17.843 V1139.727z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2252.692,
    y: 1400.628,
    style: {
      fill: "#FFFFFF"
    },
    width: 130.087,
    height: 17.117
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2009.635,
    y: 1400.628,
    style: {
      fill: "#FFFFFF"
    },
    width: 106.124,
    height: 17.117
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2642.954,
    y: 1400.628,
    style: {
      fill: "#D8DEE8"
    },
    width: 102.7,
    height: 17.117
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2995.558,
    y: 1400.628,
    style: {
      fill: "#FFFFFF"
    },
    width: 99.277,
    height: 17.117
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2286.926,
    y: 1448.554,
    style: {
      fill: "#D8DEE8"
    },
    width: 130.087,
    height: 516.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2215.036,
    y: 1448.554,
    style: {
      fill: "#97A6B7"
    },
    width: 71.89,
    height: 516.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2242.422,
    y: 1376.664,
    style: {
      fill: "#97A6B7"
    },
    width: 23.963,
    height: 102.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2365.663,
    y: 1376.664,
    style: {
      fill: "#D8DEE8"
    },
    width: 17.117,
    height: 102.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3012.675,
    y: 1448.554,
    style: {
      fill: "#D8DEE8"
    },
    width: 130.087,
    height: 516.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2947.631,
    y: 1448.554,
    style: {
      fill: "#97A6B7"
    },
    width: 65.044,
    height: 516.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2971.594,
    y: 1376.664,
    style: {
      fill: "#97A6B7"
    },
    width: 23.963,
    height: 102.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3084.565,
    y: 1376.664,
    style: {
      fill: "#D8DEE8"
    },
    width: 27.387,
    height: 102.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2663.494,
    y: 1448.554,
    style: {
      fill: "#D8DEE8"
    },
    width: 133.51,
    height: 516.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2588.18,
    y: 1448.554,
    style: {
      fill: "#97A6B7"
    },
    width: 75.314,
    height: 516.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2618.99,
    y: 1376.664,
    style: {
      fill: "#97A6B7"
    },
    width: 23.963,
    height: 102.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2738.807,
    y: 1376.664,
    style: {
      fill: "#D8DEE8"
    },
    width: 23.963,
    height: 102.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2033.598,
    y: 1448.554,
    style: {
      fill: "#D8DEE8"
    },
    width: 112.97,
    height: 516.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1975.402,
    y: 1448.554,
    style: {
      fill: "#97A6B7"
    },
    width: 58.197,
    height: 516.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1999.365,
    y: 1376.664,
    style: {
      fill: "#97A6B7"
    },
    width: 20.54,
    height: 102.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2098.642,
    y: 1376.664,
    style: {
      fill: "#D8DEE8"
    },
    width: 27.387,
    height: 102.7
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2296.731,2938.831 1976.166,2909.69 1976.166,1948.497 2296.731,1931.615  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#97A6B7"
    },
    points: "2265.161,1967.818 1964.024,1978.163 1964.024,1922.723 2265.161,1910.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#97A6B7"
    },
    points: "2265.161,2381.118 1964.024,2380.107 1964.024,2324.667 2265.161,2324.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3163.714,2905.068 2287.017,2939.375 2287.017,1925.497 3163.714,1942.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "3185.571,1967.588 2265.161,1966.565 2265.161,1906.881 3185.571,1911.064  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "3185.571,2360.995 2265.161,2381.961 2265.161,2324.665 3185.571,2306.732  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "3185.571,2890.059 2265.161,2940.598 2265.161,2931.048 3185.571,2881.015  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2551.726,2276.81 2345.302,2280.325 2345.302,2026.085 2551.726,2025.584  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2835.864,2271.987 2636.725,2275.365 2636.725,2025.386 2835.864,2024.942  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "3112.715,2267.264 2918.433,2270.549 2918.433,2024.719 3112.715,2024.277  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2551.726,2800.392 2345.302,2810.189 2345.302,2558.325 2551.726,2551.514  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "3112.715,2773.678 2918.433,2782.886 2918.433,2539.354 3112.715,2532.961  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#97A6B7"
    },
    d: "M2287.017,1968.982c0,0,176.543,23.771,252.572,141.219 c75.36,116.415,245.406,67.694,393.544,98.146c145.561,29.922,232.258,101.044,232.258,101.044l-878.374,19.614V1968.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#97A6B7"
    },
    d: "M2287.017,2569.992c0,0,176.543,17.76,252.572,132.622 c75.36,113.851,245.406,59.343,393.544,84.755c145.561,24.971,232.258,93.146,232.258,93.146l-878.374,49.499V2569.992z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4E9F2"
    },
    points: "2835.864,2853.813 2636.725,2864.101 2636.725,2501.982 2835.864,2495.944  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2867.434,2513.436 2607.582,2521.585 2607.582,2470.1 2867.434,2462.735  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2583.2971,
    y1: 2843.9592,
    x2: 2891.7195,
    y2: 2843.9592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    points: "2891.719,2850.985 2583.297,2866.852 2583.297,2836.385 2891.719,2821.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2920.862,2879.253 2549.298,2899.134 2549.298,2868.607 2920.862,2849.39  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084501944733634897720000013791346492014438805_",
    gradientUnits: "userSpaceOnUse",
    x1: 2532.2981,
    y1: 2904.4204,
    x2: 2940.2898,
    y2: 2904.4204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000084501944733634897720000013791346492014438805_)"
    },
    points: "2940.29,2908.069  2532.298,2930.601 2532.298,2900.043 2940.29,2878.24  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060708663158724191050000004674515581933313206_",
    gradientUnits: "userSpaceOnUse",
    x1: 2511.4529,
    y1: 1876.4963,
    x2: 2194.8079,
    y2: 4327.9248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060708663158724191050000004674515581933313206_)"
    },
    d: "M2360.409,2908.785 c122.978-15.8,278.901-57.315,341.525-174.377c14.898-27.85,29.847-81.949-7.754-102.322 c-34.372-18.622-78.821,1.047-104.367,25.281c-18.783,17.817-33.441,57.584-54.546,70.16 c-30.889,18.406-47.519-31.816-46.869-52.541c1.453-46.34,58.455-65.311,96.338-75.373 c62.882-16.702,136.094-31.018,132.155-101.881c-3.94-70.863-73.031-113.366-126.183-82.368 c-43.792,25.546-37.627,80.068-67.55,112.78c-26.583,29.061-35.833-18.109-34.059-41.235 c3.856-50.233,48.024-86.566,80.522-120.227c36.743-38.058,77.337-114.629,38.172-164.951 c-22.537-28.958-79.791-35.74-113.631-30.854c-165.642,23.916-55.804,238.276-85.921,262.192 c-30.117,23.916-58.612-17.95-58.537-81.609c0.075-63.659-9.669-110.606-76.103-90.233 c-66.434,20.373-79.08,186.651-3.223,250.552c75.857,63.901-4.761,133.62-25.126,87.824 c-14.702-33.066-27.627-119.661-70.117-129.159c-70.8-15.796-69.75,128.771-49.375,162.417 c28.563,47.166,93.148,57.412,129.217,98.105c10.479,11.822,34.135,41.099,24.945,58.379 c-12.816,24.099-48.574-1.682-61.711-12.851c-29.535-25.11-70.415-110.444-112.023-53.774 C2054.814,2792.698,2140.735,2896.433,2360.409,2908.785z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2378.123,2896.629c-2.889,0-5.258-2.436-5.311-5.337 c-0.048-2.511-3.47-254.661,106.617-554.477c1.014-2.754,4.071-4.197,6.822-3.187c2.756,1.011,4.169,4.05,3.157,6.805 c-109.41,297.966-106.017,548.175-105.97,550.666c0.055,2.935-2.279,5.529-5.213,5.529 C2378.19,2896.629,2378.156,2896.629,2378.123,2896.629z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170981463918774383740000016098288312710190265_",
    gradientUnits: "userSpaceOnUse",
    x1: 2959.1096,
    y1: 266.5062,
    x2: 2719.0781,
    y2: 2124.8035,
    gradientTransform: "matrix(0.962 0.2731 -0.2731 0.962 256.1541 -109.1335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3673,
    style: {
      stopColor: "#8F76EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170981463918774383740000016098288312710190265_)"
    },
    d: "M2442.926,2835.88 c-17.079-25.555-73.433-9.174-96.53-3.413c-13.395,3.342-32.038,9.009-44.225-0.812c-12.8-10.315-7.438-25.303,4.438-33.632 c21.262-14.911,53.014-11.652,77.671-14.861c26.487-3.446,52.086-11.11,70.49-31.629c14.675-16.36,24.767-43.839,19.631-65.515 c-14.215-59.986-67.781-31.533-100.086-7.333c-15.676,11.743-48.584,30.295-62.957,7.12 c-15.29-24.654,11.928-53.146,32.126-63.38c26.398-13.376,55.525-19.612,83.067-29.936c24.834-9.308,52.083-25.009,46.032-55.728 c-4.675-23.732-28-42.755-51.197-47.442c-53.635-10.838-83.569,63.463-126.484,83.071c-15.172,6.933-45.3,7.315-56.978-7.03 c-11.877-14.622,4.523-35.69,13.549-47.166c26.754-34.012,176.939-130.87,87.45-173.795 c-22.523-10.804-57.277-12.615-80.16-2.842c-43.17,18.438-77.772,69.404-99.14,109.471 c-33.611,63.024-53.964,137.846-56.691,209.242c-6.024,157.791,64.852,229.146,64.852,229.146 c33.065,22.362,76.996,41.232,117.08,43.963c47.12,3.212,109.62-14.598,143.256-49.408 C2439.003,2872.71,2453.506,2851.71,2442.926,2835.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073684842178327746620000014944418151519914916_",
    gradientUnits: "userSpaceOnUse",
    x1: 627.2892,
    y1: 1993.7426,
    x2: 2418.6926,
    y2: 1993.7426,
    gradientTransform: "matrix(1 0 0 1 -24.8406 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073684842178327746620000014944418151519914916_)"
    },
    d: "M686.678,857.772l-11.4-0.66 c-38.327-1.87-72.83,39.955-72.83,75.075v2142.881c0,47.089,46.506,57.813,84.23,54.934V857.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2366.783,936.361L699.361,854.334c-38.328-1.885-69.543,25.272-69.543,60.665v2159.623 c0,35.393,31.215,60.873,69.543,56.928l1667.422-171.62c30.119-3.1,54.436-30.878,54.436-62.056V995.491 C2421.219,964.314,2396.903,937.842,2366.783,936.361z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112608924358391264400000017883780873357374386_",
    gradientUnits: "userSpaceOnUse",
    x1: 686.6672,
    y1: 1993.0237,
    x2: 2421.1233,
    y2: 1993.0237,
    gradientTransform: "matrix(1 0 0 1 -24.8406 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000112608924358391264400000017883780873357374386_)"
    },
    d: "M699.361,3102.264 c-20.674,2.088-37.535-11.727-37.535-30.8V916.437c0-19.073,16.861-33.793,37.535-32.817l1667.422,78.765 c16.282,0.769,29.499,15.117,29.499,31.985v1905.964c0,16.868-13.218,31.927-29.499,33.571L699.361,3102.264z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2259.316,2882.794 833.162,3020.202 833.162,1032.005 2259.316,1085.716  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#97A6B7"
    },
    d: "M1688.897,1095.447l-569.969,7.13l12.785-128.539 c0.964-16.701,13.039-30.412,28.935-32.855l96.527-14.833c11.364-1.746,21.152-9.258,26.118-20.044l10.467-22.731 l252.478,15.59L1688.897,1095.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M1993.265,1012.056c-2.703-14.543-14.355-24.75-29.036-25.408l-91.075-4.082 c-41.338-1.853-71.641-35.436-70.125-77.971l3.515-98.57c0.65-18.229-12.368-32.836-30.26-33.905l-29.923-1.787 c-22.817-1.363-38.009-21.477-34.809-44.737c5.593-40.647-22.256-75.725-62.62-78.476 c-40.68-2.772-78.646,28.307-84.702,69.474c-0.9,6.117-2.966,12.162-6.329,17.556c-9.4,15.079-25.87,23.38-42,22.417 l-30.867-1.844c-18.703-1.117-36.475,12.01-41.213,30.48l-25.665,100.055c-11.1,43.272-52.969,74.541-97.427,72.549 l-99.906-4.478c-16.362-0.733-32.42,8.803-39.955,23.756l-60.203,119.459c-4.931,9.784,1.141,20.352,11.886,20.709 l866.391,28.777c9.483,0.315,17.529-9.14,15.782-18.536L1993.265,1012.056z M1636.651,732.432 c-11.934-0.74-20.216-11.114-18.48-23.171c1.736-12.057,12.827-21.2,24.756-20.424c11.908,0.775,20.143,11.147,18.413,23.167 C1659.61,724.024,1648.564,733.17,1636.651,732.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AABBCC"
    },
    d: "M1998.397,1014.728c-2.704-14.542-14.355-24.75-29.036-25.408l-91.075-4.082 c-41.337-1.853-71.641-35.436-70.125-77.971l3.515-98.57c0.65-18.229-12.368-32.836-30.26-33.905l-29.923-1.787 c-22.818-1.363-38.009-21.478-34.809-44.736c5.593-40.648-22.257-75.725-62.619-78.476 c-40.68-2.772-78.646,28.306-84.703,69.474c-0.9,6.117-2.966,12.162-6.329,17.556c-9.4,15.079-25.87,23.38-42,22.416 l-30.867-1.844c-18.703-1.117-36.475,12.01-41.213,30.48l-25.664,100.055c-11.1,43.272-52.969,74.541-97.428,72.549 l-99.906-4.478c-16.362-0.733-32.42,8.803-39.955,23.755l-60.203,119.459c-4.93,9.784,1.141,20.352,11.886,20.709 l866.391,28.777c9.483,0.315,17.529-9.14,15.782-18.536L1998.397,1014.728z M1641.783,735.104 c-11.934-0.74-20.216-11.114-18.48-23.171c1.736-12.057,12.827-21.2,24.755-20.424c11.909,0.776,20.144,11.147,18.413,23.167 C1664.741,726.696,1653.696,735.842,1641.783,735.104z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M1850.125,1069.624c-77.283-47.709-136.583-13.881-184.749-67.691 c-51.563-57.603-16.785-133.438-70.136-169.222c-34.156-22.91-64.624-2.703-104.349-8.906 c-14.545-2.27-30.068-8.052-46.198-19.322l-21.404,83.446c-11.1,43.273-52.969,74.54-97.427,72.549l-99.906-4.477 c-16.362-0.733-32.42,8.804-39.956,23.755l-60.203,119.46c-4.93,9.782,1.141,20.353,11.886,20.708l787.371,26.153 C1905.222,1114.58,1880.586,1088.427,1850.125,1069.624z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1780.271,1269.61 1386.587,1257.716 1386.587,1217.912 1780.271,1231.228  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1865.855,1355.723 1297.58,1343.463 1297.58,1303.371 1865.855,1317.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2149.992,1514.012 979.209,1505.533 979.209,1472.545 2149.992,1484.312  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2149.992,1580.838 979.209,1579.758 979.209,1546.769 2149.992,1551.138  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2149.992,1643.951 979.209,1649.859 979.209,1616.871 2149.992,1614.251  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2149.992,2315.919 979.209,2396.231 979.209,2363.242 2149.992,2286.219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2149.992,2382.745 979.209,2470.456 979.209,2437.467 2149.992,2353.044  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2149.992,2449.57 979.209,2544.68 979.209,2511.692 2149.992,2419.87  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2122.605,1766.941 1105.872,1783.731 1105.872,1755.189 2122.605,1740.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2122.605,1833.929 1105.872,1857.124 1105.872,1824.505 2122.605,1804.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2122.605,1900.917 1105.872,1930.517 1105.872,1897.898 2122.605,1871.145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1040.829,1784.781 1010.019,1785.443 1010.019,1756.657 1040.829,1756.084  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2122.605,2042.336 1105.872,2085.458 1105.872,2056.917 2122.605,2016.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2122.605,2109.324 1105.872,2158.852 1105.872,2126.232 2122.605,2079.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2122.605,2176.313 1105.872,2232.245 1105.872,2199.625 2122.605,2146.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1040.829,2088.152 1010.019,2089.744 1010.019,2060.959 1040.829,2059.455  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2149.992,2638.909 1841.891,2668.52 1841.891,2641.797 2149.992,2612.922  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2149.992,2728.01 1841.891,2760.142 1841.891,2729.601 2149.992,2698.31  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080922875163396319970000002618243372537072817_",
    gradientUnits: "userSpaceOnUse",
    x1: 3323.113,
    y1: 3446.4648,
    x2: 3695.3354,
    y2: 3446.4648,
    gradientTransform: "matrix(0.7725 0.635 -0.635 0.7725 1389.7626 -2262.9907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080922875163396319970000002618243372537072817_)"
    },
    d: "M1789.199,2790.281 c-86.562-59.311-99.21-182.282-27.789-272.192c70.498-88.749,195.35-110.245,277.967-49.808 c81.352,59.512,93.029,177.759,26.393,265.404C1998.287,2822.444,1874.406,2848.662,1789.199,2790.281z M2024.931,2486.873 c-72.997-53.2-183.061-33.994-245.076,44.282c-62.728,79.177-51.627,187.379,24.434,239.703 c75.011,51.601,184.32,28.721,243.989-49.563C2107.286,2643.88,2096.94,2539.353,2024.931,2486.873z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163031239815518763700000004590503182858601900_",
    gradientUnits: "userSpaceOnUse",
    x1: 3378.0952,
    y1: 3445.1997,
    x2: 3642.8889,
    y2: 3445.1997,
    gradientTransform: "matrix(0.7725 0.635 -0.635 0.7725 1389.7626 -2262.9907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163031239815518763700000004590503182858601900_)"
    },
    d: "M1826.014,2742.896 c-61.03-42.225-69.923-129.213-19.623-192.945c49.839-63.147,138.565-78.929,197.605-36.134 c58.394,42.327,66.798,126.926,18.919,189.51C1974.602,2766.48,1886.366,2784.651,1826.014,2742.896z M1989.455,2532.534 c-49.334-35.625-123.307-22.295-164.769,30.377c-41.781,53.077-34.399,125.466,16.318,160.693 c50.246,34.901,123.879,19.909,164.28-32.766C2045.38,2638.559,2038.338,2567.833,1989.455,2532.534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057127180579552562630000011279610317837944491_",
    gradientUnits: "userSpaceOnUse",
    x1: 3429.7886,
    y1: 3400.0178,
    x2: 3590.3931,
    y2: 3400.0178,
    gradientTransform: "matrix(0.7725 0.635 -0.635 0.7725 1389.7626 -2262.9907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057127180579552562630000011279610317837944491_)"
    },
    d: "M1991.753,2642.254l-113.327-80.689 c-4.996-3.557-5.717-10.692-1.609-15.928c4.104-5.232,11.472-6.583,16.454-3.022l113.017,80.778 c4.875,3.484,5.576,10.521,1.571,15.726C2003.85,2644.327,1996.641,2645.735,1991.753,2642.254z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143617067385911916360000009761315623224275841_",
    gradientUnits: "userSpaceOnUse",
    x1: 3415.97,
    y1: 3444.1604,
    x2: 3602.6287,
    y2: 3444.1604,
    gradientTransform: "matrix(0.7725 0.635 -0.635 0.7725 1389.7626 -2262.9907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143617067385911916360000009761315623224275841_)"
    },
    d: "M1973.892,2683.252l-134.917-95.385 c-5.032-3.558-5.759-10.717-1.621-15.982c4.134-5.261,11.556-6.634,16.574-3.073l134.548,95.492 c4.891,3.471,5.595,10.518,1.576,15.746C1986.03,2685.281,1978.797,2686.719,1973.892,2683.252z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003063128889402817310000000526107620470540713_",
    gradientUnits: "userSpaceOnUse",
    x1: 3431.8191,
    y1: 3488.2158,
    x2: 3593.2034,
    y2: 3488.2158,
    gradientTransform: "matrix(0.7725 0.635 -0.635 0.7725 1389.7626 -2262.9907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003063128889402817310000000526107620470540713_)"
    },
    d: "M1938.117,2711.853l-114.473-80.357 c-5.046-3.542-5.775-10.709-1.626-15.998c4.146-5.286,11.589-6.69,16.621-3.144l114.158,80.449 c4.924,3.47,5.632,10.538,1.587,15.794C1950.337,2713.857,1943.055,2715.319,1938.117,2711.853z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118378406544053667040000010642436939342109313_",
    gradientUnits: "userSpaceOnUse",
    x1: 10724.9414,
    y1: 2961.4966,
    x2: 10746.6416,
    y2: 3237.6831,
    gradientTransform: "matrix(1 -0.0024 0.0024 1 -7774.4131 3.3687)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118378406544053667040000010642436939342109313_)"
    },
    d: "M2998.385,3077.713l10.2,16.286 c2.853,4.555,3.713,10.044,2.364,15.247c-3.521,13.573-10.554,40.024-13.632,46.925c-4.19,9.399-60.708,15.112-60.708,15.112 s-5.058-7.081,6.659-15.678c11.715-8.596,19.257-9.961,23.37-22.616c4.11-12.652,6.788-48.423,6.788-48.423L2998.385,3077.713z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023262009403221771130000000521094671282903698_",
    gradientUnits: "userSpaceOnUse",
    x1: 10746.7031,
    y1: 3142.2966,
    x2: 10742.7578,
    y2: 2856.2375,
    gradientTransform: "matrix(1 -0.0024 0.0024 1 -7774.4131 3.3687)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023262009403221771130000000521094671282903698_)"
    },
    d: "M2955.993,3036.362 c3.719,2.95,22.007,58.014,22.007,58.014s5.896,7.501,17.033-3.616c11.136-11.118,5.041-4.987,5.041-4.987l-2.225-54.196 L2955.993,3036.362z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014618458963437431470000012362752134589194668_",
    gradientUnits: "userSpaceOnUse",
    x1: 5106.0835,
    y1: 2828.4478,
    x2: 5229.5986,
    y2: 3274.176,
    gradientTransform: "matrix(1 0 0 1 -2562.7559 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014618458963437431470000012362752134589194668_)"
    },
    d: "M2665.039,3081.122 c0,0,5.89,23.874,6.076,32.523c0.188,8.65-94.995,20.706-96.477,14.334c-1.482-6.373,14.453-17.97,25.956-22.534 c11.504-4.565,45.249-16.991,45.249-16.991L2665.039,3081.122z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025416039719620997670000006239503225513652617_",
    gradientUnits: "userSpaceOnUse",
    x1: 5216.0122,
    y1: 3143.5815,
    x2: 5217.8022,
    y2: 2993.2148,
    gradientTransform: "matrix(1 0 0 1 -2562.7559 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025416039719620997670000006239503225513652617_)"
    },
    d: "M2639.917,3058.864l5.457,29.835 c0,0,11.686,6.444,21.009,0l2.269-33.132L2639.917,3058.864z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021079922888533150340000007213520521660161960_",
    gradientUnits: "userSpaceOnUse",
    x1: 5129.3389,
    y1: 2659.9841,
    x2: 5289.4355,
    y2: 2659.9841,
    gradientTransform: "matrix(1 0 0 1 -2562.7559 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021079922888533150340000007213520521660161960_)"
    },
    d: "M2716.056,2249.588 c-21.914,4.075-43.826,8.15-65.74,12.231c-34.231,72.41-39.564,145.35-30.029,176.659c13.488,44.299,40.77,56.65,42.961,102.036 c2.169,44.908-23.292,58.638-35.802,112.776c-8.66,37.483-2.909,70.847,8.952,136.046 c23.887,131.332,59.102,169.259,35.801,214.812c-6.622,12.944-19.154,28.73-45.118,42.097 c1.308,8.066,2.608,16.159,3.946,24.135c14.917-1.883,29.835-3.776,44.753-5.659c18.208-44.71,38.549-111.854,34.461-192.403 c-4.263-84.021-30.568-93.115-35.387-173.502c-6.246-104.191,35.15-135.438,48.363-262.426 C2728.269,2387.826,2729.244,2324.846,2716.056,2249.588z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176742971730189932580000000696482805684137124_",
    gradientUnits: "userSpaceOnUse",
    x1: 10361.3154,
    y1: 2663.2324,
    x2: 10787.0898,
    y2: 2663.2324,
    gradientTransform: "matrix(1 -0.0024 0.0024 1 -7774.4131 3.3687)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176742971730189932580000000696482805684137124_)"
    },
    d: "M2592.44,2285.597 c77.292,112.513,160.704,252.571,235.402,420.274c56.449,126.735,97.456,245.755,127.607,351.845 c4.05,1.862,13.602,5.576,25.792,3.935c16.627-2.24,26.571-12.881,29.169-15.85c11.985-76.132,10.489-140.582,6.248-187.089 c-2.716-29.776-7.515-79.363-26.646-140.546c-21.428-68.534-36.056-72.352-63.972-144.848 c-28.973-75.246-22.044-94.056-49.844-188.242c-11.421-38.693-30.521-96.265-61.975-165.113 C2740.293,2241.839,2666.366,2263.719,2592.44,2285.597z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086680692422208447010000005828535873974155946_",
    gradientUnits: "userSpaceOnUse",
    x1: 5659.2871,
    y1: 2013.0831,
    x2: 5890.9253,
    y2: 2013.0831,
    gradientTransform: "matrix(1 0 0 1 -3309.689 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086680692422208447010000005828535873974155946_)"
    },
    d: "M2390.051,2236.754l-33.234-18.905 c0,0-6.4-20.413-7.216-160.356c-0.815-139.943,160.366-265.153,209.918-268.052c49.55-2.899-1.196,220.696-1.196,220.696 c-12.351-2.57-30.31-4.326-49.425,1.929c-49.178,16.09-69.705,73.308-87.25,122.216 C2412.358,2160.181,2393.312,2187.929,2390.051,2236.754z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101801459145489395010000009929043088202429575_",
    gradientUnits: "userSpaceOnUse",
    x1: 5222.7817,
    y1: 1893.8138,
    x2: 5174.2563,
    y2: 3584.1238,
    gradientTransform: "matrix(1 0 0 1 -2562.7559 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101801459145489395010000009929043088202429575_)"
    },
    d: "M2594.329,2272.231 c-9.249,23.273-18.498,46.546-27.748,69.818c1.357,128.476,8.076,267.758,22.816,416.106 c10.966,110.371,25.266,214.612,41.628,312.225c14.917-1.885,29.835-3.776,44.753-5.661 c18.208-44.705,38.549-111.853,34.461-192.401c-4.263-84.02-30.568-93.113-35.387-173.501 c-6.246-104.19,35.15-135.44,48.363-262.428c5.053-48.564,6.029-111.544-7.16-186.802 C2675.479,2257.134,2634.906,2264.686,2594.329,2272.231z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181081287017633800230000012660650463214475688_",
    gradientUnits: "userSpaceOnUse",
    x1: 6014.8701,
    y1: 1845.9059,
    x2: 5975.2295,
    y2: 2568.2485,
    gradientTransform: "matrix(1 0 0 1 -3309.689 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181081287017633800230000012660650463214475688_)"
    },
    d: "M2555.841,2365.979 c-17.839-24.864-0.082-51.647,0.454-101.507c0.606-56.509-21.753-64.119-50.577-155.377 c-19.168-60.693-37.569-118.959-26.851-189.748c5.136-33.927,13.848-91.468,58.406-122.495 c22.994-16.011,56.043-17.243,121.202-19.047c80.576-2.234,120.864-3.352,152.047,10.006 c4.564,1.956,99.557,44.174,112.29,124.377c12.96,81.629-75.61,99.838-78.764,210.333 c-1.415,49.602,14.192,124.467,24.314,173.024c9.719,46.624,14.777,58.356,6.625,73.36 c-19.648,36.166-89.019,31.865-227.761,23.27C2592.802,2388.802,2569.153,2384.533,2555.841,2365.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091003131178657086350000006156586571897826738_",
    gradientUnits: "userSpaceOnUse",
    x1: 5321.0439,
    y1: 1728.4589,
    x2: 5281.4038,
    y2: 2450.7998,
    gradientTransform: "matrix(1 0 0 1 -2562.7559 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000091003131178657086350000006156586571897826738_)"
    },
    d: "M2745.592,2112.676 c7.511,20.885,29.649,35.159,48.332,85.925c4.033,10.962,32.761,89.014,5.371,110.989c-15.822,12.691-32.563-7.611-73.393-7.165 c-70.752,0.771-99.533,62.593-146.789,50.127c-8.199-2.167-19.206-7.296-30.817-20.181c-1.102,12.538,0.118,23.252,7.545,33.606 c13.312,18.555,36.961,22.823,91.384,26.196c138.742,8.595,208.113,12.896,227.761-23.27c8.152-15.004,3.094-26.736-6.625-73.36 c-10.122-48.558-25.729-123.422-24.314-173.024c3.153-110.494,91.724-128.704,78.764-210.333 c-3.464-21.822-13.109-40.728-25.274-56.881C2787.738,1910.32,2721.985,2047.049,2745.592,2112.676z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013890828749915841910000001681071662561646468_",
    gradientUnits: "userSpaceOnUse",
    x1: 2376.5891,
    y1: 253.3092,
    x2: 2376.5891,
    y2: 123.0483,
    gradientTransform: "matrix(0.827 0.5622 -0.5622 0.827 795.198 289.0357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013890828749915841910000001681071662561646468_)"
    },
    d: "M2650.056,1710.186 c0,0,3.146,25.027,12.451,43.212c8.408,16.435,46.325,24.153,54.141,27.345c7.817,3.192-12.881,16.015-34.385,19.932 c-21.503,3.917-83.806,3.955-95.624-3.369c-11.819-7.323,8.358-8.318,23.377-15.239c15.017-6.92,21.539-37.898,17.707-51.413 C2623.893,1717.136,2650.056,1710.186,2650.056,1710.186z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143589528746011322340000016053066307903355531_",
    gradientUnits: "userSpaceOnUse",
    x1: 5243.481,
    y1: 1779.4584,
    x2: 5200.2788,
    y2: 1669.7336,
    gradientTransform: "matrix(1 0 0 1 -2562.7559 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143589528746011322340000016053066307903355531_)"
    },
    d: "M2623.54,1703.718 c-12.232-10.232-13.919-11.407-15.463-15.159c-6.194-15.059,11.381-18.772,26.687-25.243c0.796-0.335,12.978-6.625,17.37-2.372 c3.73,3.611-10.06-6.967-7.069,0.329c2.801,6.83,8.92,6.868,20.919,15.158c9.885,6.827,16.027,11.071,17.888,17.585 c3.836,13.429-11.101,34.534-25.771,35.168C2652.826,1729.413,2651.181,1726.841,2623.54,1703.718z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130626731308627994910000012864214662487100055_",
    gradientUnits: "userSpaceOnUse",
    x1: 2291.3528,
    y1: 211.457,
    x2: 2352.7468,
    y2: 92.0798,
    gradientTransform: "matrix(0.827 0.5622 -0.5622 0.827 795.198 289.0357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130626731308627994910000012864214662487100055_)"
    },
    d: "M2656.84,1731.408 c0,0-10.96,14.614-29.683,11.573c-16.764-2.722-15.592-40.789-4.044-47.781c3.852-2.332,11.158-2.75,16.855-0.547 c3.365,1.302,4.396,2.851,9.935,4.872c5.108,1.862,6.646,1.424,8.098,2.908c1.818,1.855,2.874,6.076-1.494,16.818 c3.533-2.95,7.516-3.828,10.128-2.273c0.417,0.249,1.5,1.149,2.036,2.405 C2670.613,1723.933,2666.136,1729.072,2656.84,1731.408z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044169026642556763240000015676217967577344923_",
    gradientUnits: "userSpaceOnUse",
    x1: 4448.4805,
    y1: 2109.4426,
    x2: 4444.437,
    y2: 1920.3949,
    gradientTransform: "matrix(1 0 0 1 -1833.5931 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044169026642556763240000015676217967577344923_)"
    },
    d: "M2547.945,1988.009 c0,0-31.917,63.353,57.72,62.005c89.637-1.348,76.303-70.767,76.303-70.767L2547.945,1988.009z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119098294944292828280000013727955941858514075_",
    gradientUnits: "userSpaceOnUse",
    x1: 5663.812,
    y1: 1326.6769,
    x2: 5771.6685,
    y2: 1353.8755,
    gradientTransform: "matrix(0.604 0.797 0.797 -0.604 -2137.2971 -1509.6281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119098294944292828280000013727955941858514075_)"
    },
    d: "M2403.293,2237.036 c0,0-35.107,9.206-51.253-1.043c-16.146-10.249-23.266-46.041-23.266-46.041s17.987-4.217,29.883,11.48 C2370.554,2217.129,2410.425,2221.366,2403.293,2237.036z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028284545974160789530000002906585482208262545_",
    gradientUnits: "userSpaceOnUse",
    x1: 6217.2363,
    y1: 1868.4572,
    x2: 6171.8765,
    y2: 2695.0237,
    gradientTransform: "matrix(1 0 0 1 -3309.689 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028284545974160789530000002906585482208262545_)"
    },
    d: "M2797.202,1783.137 c0,0-11.595,41.019,9.661,169.295c21.257,128.276,102.394,146.817,51.197,224.631c-51.197,77.813-72.454,72.525-72.454,72.525 l6.575,22.906c0,0,139.323,2.653,196.735-76.345S2993.937,1801.377,2797.202,1783.137z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119810292090815440000000003119209601768763525_",
    gradientUnits: "userSpaceOnUse",
    x1: 4228.126,
    y1: 1076.5343,
    x2: 4326.8848,
    y2: 1076.5343,
    gradientTransform: "matrix(1.2009 0.3785 -0.3006 0.9538 -2518.7185 -765.4113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8DEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119810292090815440000000003119209601768763525_)"
    },
    d: "M2243.696,1834.878 c0,0,34.13-42.964,60.809-54.091c-17.637,70.953,19.862,211.819,19.862,211.819S2231.729,1907.617,2243.696,1834.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2776.367,2530.185c-112.921,23.733-304.172-90.064-325.605-123.516 c-22.999-36.029-144.098-254.238-190.227-431.76c-11.604-44.875-22.065-88.283-17.728-123.186 c0.019-0.059,0.038-0.119,0.038-0.119c1.661-5.272,0.355-11.348,0.897-16.712c4.448,33.764,28.449,56.695,63.088,71.909 c122.237,53.63,377.287,11.526,377.287,11.526l173.944,507.957C2852.762,2490.708,2820.562,2521.062,2776.367,2530.185z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108282434064682805280000010604394070878330514_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.8618,
    y1: 2248.7056,
    x2: 66.4985,
    y2: 2351.9285,
    gradientTransform: "matrix(-0.9655 0.2606 0.2606 0.9655 2310.9856 41.2271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108282434064682805280000010604394070878330514_)"
    },
    d: "M2815.598,2272.368 c0,0,4.76-15.458-2.133-24.125c-6.892-8.667-25.681-19.116-25.681-19.116c-2.617,1.514-5.917,4.005-6.498,7.614 c-1.033,6.427,7.588,9.983,13.767,19.32c10.032,15.158,4.554,33.864,8.829,32.711 C2807.156,2287.889,2815.598,2272.368,2815.598,2272.368z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106862411491991806760000009561186238239822510_",
    gradientUnits: "userSpaceOnUse",
    x1: 6321.7852,
    y1: -1489.0319,
    x2: 6460.6021,
    y2: -1378.86,
    gradientTransform: "matrix(0.5846 0.8114 -0.8114 0.5846 -2248.0383 -2573.385)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106862411491991806760000009561186238239822510_)"
    },
    d: "M2614.793,1670.417 c0,0,44.355,25.091,63.984,41.154c3.478,2.846,8.669,2.023,11.042-1.792c7.177-11.537,16.604-34.853-8.782-52.939 C2648.958,1633.985,2626.449,1650.708,2614.793,1670.417z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122685633318561981770000009698606148807150476_",
    gradientUnits: "userSpaceOnUse",
    x1: 6302.4399,
    y1: -1438.4949,
    x2: 6307.4326,
    y2: -1465.6769,
    gradientTransform: "matrix(0.5846 0.8114 -0.8114 0.5846 -2248.0383 -2573.385)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122685633318561981770000009698606148807150476_)"
    },
    d: "M2618.928,1667.438 c0,0-17.133-5.748-17.888-1.101s67.454,37.505,67.454,37.505L2618.928,1667.438z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108297665564430521090000003443076019509982892_",
    gradientUnits: "userSpaceOnUse",
    x1: 6283.2212,
    y1: -1520.2111,
    x2: 6354.228,
    y2: -1435.8904,
    gradientTransform: "matrix(0.5846 0.8114 -0.8114 0.5846 -2248.0383 -2573.385)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108297665564430521090000003443076019509982892_)"
    },
    d: "M2669.588,1665.089 c3.133-4.471,9.026-5.574,15.458-5.08c-1.236-1.071-2.55-2.131-4.009-3.17c-28.412-20.242-49.31-9.434-61.815,6.993 c7.552,4.385,15.919,9.35,20.355,12.346C2648.885,1682.465,2660.294,1678.348,2669.588,1665.089z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142170036868215515910000007776569803562292631_",
    gradientUnits: "userSpaceOnUse",
    x1: 2782.7292,
    y1: 1155.7705,
    x2: 2345.1589,
    y2: 899.3062,
    gradientTransform: "matrix(1 0 0 1 51.8385 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142170036868215515910000007776569803562292631_)"
    },
    d: "M2644.425,1100.997 c27.968,14.2,63.105,1.161,78.48-29.122c15.376-30.283,5.167-66.344-22.801-80.544c-1.448-0.736-2.927-1.354-4.41-1.946 c5.196-16.757,9.114-33.645,11.741-50.539c1.603-0.005,3.212-0.032,4.846-0.177c31.909-2.845,57.233-32.165,56.566-65.493 c-0.668-33.327-27.077-58.038-58.986-55.193c-1.668,0.15-3.306,0.413-4.935,0.702c-3.333-16.515-7.9-32.649-13.661-48.263 c1.468-0.859,2.928-1.746,4.355-2.746c27.299-19.125,36.027-56.875,19.494-84.314c-16.533-27.439-52.067-34.178-79.366-15.052 c-1.399,0.98-2.714,2.039-4.015,3.113c-10.782-11.92-22.609-22.966-35.403-33.048c0.899-1.475,1.78-2.969,2.576-4.538 c15.375-30.283,35.468-63.363,7.281-77.123c-65.205-31.831-93.185-4.583-108.562,25.701c-0.796,1.569-1.483,3.162-2.143,4.758 c-15.689-4.38-31.586-7.409-47.572-9.081c0.1-1.684,0.178-3.37,0.144-5.079c-0.669-33.325,9.22-51.36-22.81-51.983 c-69.845-1.358-93.41,28.958-92.742,62.283c0.035,1.742,0.181,3.445,0.353,5.137c-16.006,4.563-31.725,10.395-47.025,17.451 c-0.728-1.487-1.482-2.964-2.346-4.399c-16.533-27.439-52.066-34.177-79.366-15.051c-27.3,19.127-36.028,56.875-19.494,84.313 c0.846,1.406,1.774,2.72,2.716,4.017c-12.089,12.091-23.411,25.219-33.872,39.303c-1.354-0.849-2.726-1.678-4.175-2.414 c-27.968-14.2-63.105-1.162-78.479,29.122c-15.376,30.283-5.168,66.345,22.8,80.544c1.449,0.736,2.928,1.354,4.412,1.946 c-5.196,16.757-9.115,33.645-11.741,50.539c-1.604,0.005-3.212,0.031-4.844,0.176c-31.911,2.846-57.235,32.166-56.567,65.494 c0.669,33.327,27.078,58.036,58.987,55.192c1.666-0.148,3.304-0.411,4.933-0.701c3.333,16.516,7.9,32.649,13.661,48.264 c-1.468,0.859-2.928,1.746-4.354,2.746c-27.299,19.125-36.027,56.875-19.494,84.313c16.532,27.44,71.268,40.187,98.566,21.062 c1.399-0.981-16.487-8.048-15.185-9.123c10.782,11.92,22.608,22.966,35.403,33.048c-0.898,1.475-1.78,2.969-2.576,4.538 c-15.375,30.283-5.168,66.345,22.8,80.544c27.968,14.2,63.104,1.161,78.481-29.122c0.796-1.569,1.482-3.162,2.143-4.758 c15.689,4.381,31.585,7.41,47.571,9.081c-0.099,1.683-0.177,3.371-0.144,5.079c0.669,33.325,27.078,58.036,58.986,55.192 c31.908-2.845,57.234-32.167,56.566-65.492c-0.036-1.742-0.181-3.445-0.354-5.136c16.006-4.562,31.726-10.395,47.026-17.451 c0.727,1.487,1.482,2.964,2.346,4.397c16.533,27.439,52.066,34.179,79.366,15.052c27.301-19.127,36.028-56.875,19.495-84.315 c-0.847-1.405-1.775-2.719-2.717-4.016c12.089-12.091,23.411-25.22,33.873-39.303 C2641.604,1099.432,2642.977,1100.261,2644.425,1100.997z M2295.779,1105.421c-101.545-51.557-138.609-182.485-82.783-292.437 c55.825-109.953,183.399-157.292,284.943-105.735c101.545,51.556,138.608,182.485,82.784,292.437 C2524.897,1109.639,2397.323,1156.978,2295.779,1105.421z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069399744163954979630000001681021474035971733_",
    gradientUnits: "userSpaceOnUse",
    x1: 2252.5593,
    y1: 854.0525,
    x2: 2349.7974,
    y2: 897.8094,
    gradientTransform: "matrix(1 0 0 1 51.8385 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069399744163954979630000001681021474035971733_)"
    },
    d: "M2712.281,938.669 c31.909-2.845,57.233-32.167,56.566-65.493c-0.668-33.326-27.077-58.038-58.986-55.193c-1.668,0.149-3.306,0.413-4.935,0.702 c-3.332-16.516-7.9-32.648-13.661-48.263c1.468-0.858,2.928-1.746,4.355-2.747c27.299-19.125,61.073-65.339,41.813-90.936 c-36.555-48.583-74.386-27.554-101.685-8.429c-1.399,0.98-2.714,2.038-4.014,3.112c-10.784-11.92-22.61-22.965-35.405-33.047 c0.899-1.475,1.78-2.968,2.576-4.536c8.368-16.482,9.106-34.654,3.58-50.102c-26.368,46.409-52.382,93.013-77.927,139.871 c81.009,59.362,106.8,176.345,56.164,276.079c-42.909,84.515-128.206,131.97-211.491,126.024 c-3.715,9.635-7.363,19.322-11.342,28.864c-10.795,25.895-23.061,51.256-35.341,76.584c7.723,1.456,15.48,2.602,23.259,3.417 c-0.099,1.684-0.177,3.371-0.144,5.079c0.669,33.326,20.902,61.641,78.732,58.573c31.99-1.696,37.487-35.547,36.82-68.873 c-0.036-1.741-0.181-3.444-0.354-5.136c16.006-4.562,31.726-10.396,47.025-17.451c0.727,1.487,1.482,2.964,2.346,4.397 c16.533,27.441,73.887,39.099,101.187,19.972c27.301-19.127,14.206-61.794-2.327-89.234c-0.847-1.406-1.775-2.72-2.717-4.018 c12.089-12.09,23.411-25.219,33.873-39.302c1.354,0.849,2.726,1.679,4.175,2.412c27.968,14.201,63.105,1.162,78.481-29.122 c15.375-30.282,5.167-66.345-22.801-80.544c-1.449-0.736-2.928-1.354-4.411-1.945c5.196-16.757,9.114-33.646,11.741-50.539 C2709.038,938.842,2710.646,938.814,2712.281,938.669z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003093564948905664100000006070246396175315115_",
    gradientUnits: "userSpaceOnUse",
    x1: 2231.2488,
    y1: 713.4149,
    x2: 2690.5935,
    y2: 1340.3591,
    gradientTransform: "matrix(1 0 0 1 51.8385 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003093564948905664100000006070246396175315115_)"
    },
    d: "M2674.506,1104.418 c27.968,14.2,63.105,1.162,78.481-29.122c15.375-30.283,5.167-66.344-22.801-80.544c-1.448-0.735-2.928-1.354-4.411-1.945 c5.196-16.757,9.114-33.645,11.741-50.54c1.603-0.004,3.211-0.031,4.846-0.176c31.909-2.845,57.234-32.166,56.566-65.492 c-0.668-33.328-27.077-58.038-58.986-55.193c-1.668,0.149-3.305,0.412-4.935,0.702c-3.333-16.516-7.9-32.649-13.661-48.263 c1.468-0.859,2.927-1.746,4.354-2.746c27.299-19.125,36.027-56.874,19.495-84.314c-16.533-27.439-52.067-34.178-79.366-15.052 c-1.399,0.981-2.716,2.039-4.016,3.113c-10.783-11.92-22.609-22.966-35.403-33.047c0.899-1.475,1.78-2.97,2.577-4.538 c15.375-30.283,5.167-66.344-22.801-80.544c-27.969-14.201-63.104-1.162-78.48,29.121c-0.796,1.569-1.483,3.162-2.143,4.758 c-15.69-4.381-31.586-7.41-47.571-9.081c0.099-1.684,0.176-3.37,0.143-5.079c-0.669-33.325-27.077-58.036-58.987-55.192 c-31.908,2.844-57.233,32.167-56.565,65.492c0.035,1.742,0.181,3.445,0.353,5.136c-16.006,4.563-31.725,10.396-47.026,17.451 c-0.727-1.486-1.481-2.964-2.345-4.399c-16.532-27.439-52.066-34.178-79.366-15.051c-27.3,19.127-36.027,56.875-19.494,84.314 c0.847,1.405,1.775,2.72,2.718,4.017c-12.09,12.091-23.412,25.219-33.874,39.303c-1.353-0.849-2.724-1.678-4.174-2.414 c-27.968-14.2-63.105-1.161-78.48,29.122c-15.376,30.284-5.167,66.345,22.8,80.544c1.45,0.736,2.928,1.354,4.411,1.945 c-5.195,16.757-9.114,33.645-11.741,50.539c-1.602,0.005-3.212,0.031-4.845,0.176c-31.909,2.846-57.234,32.167-56.566,65.494 c0.668,33.327,27.077,58.036,58.985,55.192c1.667-0.149,3.306-0.411,4.934-0.701c3.333,16.516,7.9,32.649,13.662,48.264 c-1.468,0.858-2.928,1.745-4.354,2.745c-27.3,19.125-36.027,56.875-19.495,84.313c16.533,27.44,52.067,34.178,79.365,15.053 c1.399-0.982,2.716-2.039,4.016-3.114c10.783,11.92,22.609,22.966,35.403,33.048c-0.898,1.475-1.78,2.969-2.576,4.538 c-15.376,30.283-5.168,66.344,22.801,80.544c27.968,14.2,63.104,1.162,78.48-29.122c0.796-1.568,1.483-3.161,2.142-4.757 c15.69,4.381,31.587,7.409,47.572,9.081c-0.099,1.684-0.177,3.371-0.144,5.079c0.669,33.325,27.077,58.036,58.986,55.192 c31.908-2.845,57.234-32.167,56.565-65.493c-0.034-1.741-0.18-3.444-0.353-5.136c16.006-4.563,31.726-10.396,47.026-17.451 c0.727,1.485,1.482,2.964,2.346,4.396c16.533,27.44,52.066,34.18,79.365,15.052c27.3-19.127,36.028-56.875,19.496-84.315 c-0.848-1.404-1.776-2.719-2.718-4.016c12.089-12.09,23.411-25.219,33.873-39.302 C2671.685,1102.853,2673.056,1103.682,2674.506,1104.418z M2325.86,1108.841c-101.545-51.557-138.609-182.485-82.783-292.438 c55.826-109.953,183.399-157.291,284.944-105.735c101.545,51.556,138.608,182.485,82.784,292.438 C2554.978,1113.06,2427.406,1160.398,2325.86,1108.841z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118386826417260319080000013816846415688640944_",
    gradientUnits: "userSpaceOnUse",
    x1: 3037.2327,
    y1: 1423.0797,
    x2: 2815.6499,
    y2: 1293.2078,
    gradientTransform: "matrix(1 0 0 1 51.8385 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118386826417260319080000013816846415688640944_)"
    },
    d: "M2992.784,1395.343 c14.163,7.191,31.956,0.588,39.742-14.747c7.786-15.335,2.617-33.596-11.546-40.787c-0.733-0.373-1.482-0.686-2.233-0.985 c2.631-8.485,4.615-17.037,5.945-25.593c0.812-0.002,1.626-0.016,2.454-0.09c16.158-1.44,28.983-16.288,28.645-33.165 c-0.339-16.876-13.712-29.39-29.87-27.95c-0.845,0.076-1.674,0.209-2.499,0.356c-1.688-8.363-4-16.533-6.918-24.44 c0.743-0.435,1.483-0.884,2.205-1.391c13.824-9.685,18.244-28.801,9.872-42.696c-8.372-13.895-26.366-17.307-40.19-7.622 c-0.708,0.496-1.375,1.032-2.033,1.577c-5.46-6.036-11.449-11.63-17.928-16.735c0.456-0.747,0.901-1.504,1.305-2.298 c7.786-15.335,17.961-32.087,3.687-39.055c-33.019-16.119-47.188-2.321-54.975,13.015c-0.403,0.795-0.751,1.601-1.085,2.409 c-7.945-2.218-15.995-3.752-24.09-4.599c0.051-0.853,0.09-1.707,0.073-2.572c-0.339-16.876,4.669-26.008-11.551-26.324 c-35.369-0.688-47.302,14.664-46.964,31.54c0.018,0.882,0.092,1.745,0.179,2.601c-8.105,2.311-16.065,5.264-23.813,8.837 c-0.369-0.753-0.75-1.501-1.188-2.228c-8.372-13.895-26.366-17.307-40.19-7.621s-18.244,28.801-9.872,42.696 c0.428,0.712,0.899,1.377,1.375,2.034c-6.122,6.123-11.855,12.771-17.153,19.903c-0.686-0.43-1.38-0.85-2.114-1.222 c-14.163-7.191-31.956-0.588-39.741,14.747c-7.786,15.335-2.617,33.596,11.546,40.787c0.734,0.373,1.483,0.686,2.234,0.986 c-2.631,8.485-4.615,17.037-5.946,25.593c-0.812,0.002-1.626,0.016-2.453,0.089c-16.159,1.441-28.983,16.289-28.645,33.166 c0.339,16.876,13.712,29.389,29.871,27.949c0.844-0.075,1.674-0.208,2.498-0.355c1.688,8.364,4,16.533,6.918,24.44 c-0.743,0.435-1.483,0.884-2.205,1.391c-13.824,9.685-18.244,28.801-9.872,42.696c8.372,13.895,36.09,20.35,49.913,10.665 c0.708-0.497-8.349-4.075-7.69-4.62c5.46,6.036,11.449,11.63,17.928,16.735c-0.455,0.747-0.901,1.504-1.304,2.298 c-7.786,15.335-2.617,33.597,11.546,40.787c14.163,7.191,31.956,0.588,39.742-14.747c0.403-0.794,0.751-1.601,1.085-2.41 c7.945,2.218,15.994,3.752,24.09,4.599c-0.05,0.852-0.09,1.707-0.073,2.572c0.339,16.876,13.712,29.389,29.87,27.949 c16.158-1.44,28.983-16.289,28.645-33.165c-0.018-0.882-0.092-1.745-0.179-2.601c8.105-2.31,16.066-5.264,23.813-8.837 c0.368,0.753,0.751,1.501,1.188,2.227c8.372,13.895,26.366,17.308,40.19,7.622c13.825-9.686,18.244-28.801,9.872-42.697 c-0.429-0.711-0.899-1.377-1.376-2.034c6.122-6.123,11.855-12.771,17.153-19.903 C2991.356,1394.551,2992.051,1394.97,2992.784,1395.343z M2816.232,1397.583c-51.422-26.108-70.191-92.41-41.921-148.088 c28.27-55.68,92.872-79.652,144.294-53.544s70.19,92.409,41.921,148.088C2932.256,1399.719,2867.654,1423.691,2816.232,1397.583 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123439056677652903120000014942842189871888528_",
    gradientUnits: "userSpaceOnUse",
    x1: 2768.7581,
    y1: 1270.2916,
    x2: 2817.9988,
    y2: 1292.45,
    gradientTransform: "matrix(1 0 0 1 51.8385 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123439056677652903120000014942842189871888528_)"
    },
    d: "M3027.146,1313.141 c16.158-1.441,28.983-16.289,28.645-33.165c-0.339-16.876-13.712-29.39-29.87-27.949c-0.845,0.075-1.674,0.209-2.499,0.355 c-1.687-8.364-4-16.533-6.918-24.44c0.743-0.434,1.483-0.884,2.205-1.391c13.824-9.685,30.927-33.087,21.174-46.05 c-18.511-24.602-37.668-13.953-51.492-4.268c-0.708,0.496-1.375,1.032-2.033,1.576c-5.461-6.036-11.449-11.629-17.929-16.735 c0.456-0.747,0.901-1.503,1.305-2.297c4.238-8.346,4.612-17.548,1.813-25.371c-13.352,23.501-26.525,47.101-39.462,70.83 c41.022,30.061,54.083,89.3,28.441,139.804c-21.729,42.798-64.923,66.829-107.098,63.818c-1.881,4.879-3.729,9.785-5.743,14.617 c-5.467,13.113-11.678,25.956-17.896,38.782c3.911,0.737,7.839,1.318,11.778,1.73c-0.05,0.853-0.09,1.707-0.073,2.572 c0.339,16.876,10.585,31.214,39.87,29.661c16.199-0.859,18.983-18.001,18.645-34.877c-0.018-0.882-0.091-1.744-0.179-2.601 c8.105-2.31,16.065-5.265,23.813-8.837c0.368,0.753,0.751,1.501,1.188,2.227c8.373,13.896,37.416,19.799,51.241,10.114 c13.825-9.686,7.194-31.292-1.178-45.187c-0.429-0.712-0.899-1.377-1.376-2.034c6.122-6.122,11.855-12.771,17.153-19.902 c0.685,0.43,1.38,0.85,2.114,1.221c14.163,7.192,31.956,0.589,39.742-14.747c7.786-15.335,2.616-33.597-11.546-40.787 c-0.734-0.373-1.483-0.686-2.234-0.985c2.631-8.485,4.615-17.038,5.945-25.592 C3025.504,1313.228,3026.318,1313.214,3027.146,1313.141z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047750022918098224060000013475047435059822232_",
    gradientUnits: "userSpaceOnUse",
    x1: 2757.9666,
    y1: 1199.0736,
    x2: 2990.5759,
    y2: 1516.5542,
    gradientTransform: "matrix(1 0 0 1 51.8385 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047750022918098224060000013475047435059822232_)"
    },
    d: "M3008.017,1397.075 c14.163,7.191,31.956,0.589,39.742-14.747c7.786-15.335,2.616-33.596-11.546-40.787c-0.734-0.372-1.483-0.685-2.233-0.985 c2.631-8.485,4.615-17.037,5.945-25.593c0.812-0.002,1.626-0.016,2.454-0.089c16.158-1.44,28.983-16.288,28.645-33.165 c-0.338-16.877-13.712-29.39-29.87-27.95c-0.845,0.076-1.674,0.209-2.499,0.355c-1.688-8.364-4-16.533-6.918-24.44 c0.743-0.435,1.482-0.884,2.205-1.391c13.824-9.685,18.244-28.801,9.872-42.696c-8.372-13.895-26.366-17.307-40.19-7.622 c-0.708,0.497-1.375,1.033-2.033,1.576c-5.46-6.036-11.449-11.63-17.928-16.735c0.455-0.747,0.901-1.504,1.305-2.298 c7.786-15.335,2.616-33.596-11.546-40.787c-14.163-7.191-31.956-0.588-39.742,14.747c-0.403,0.795-0.751,1.601-1.085,2.41 c-7.945-2.218-15.995-3.752-24.09-4.599c0.05-0.853,0.089-1.707,0.073-2.572c-0.339-16.876-13.712-29.389-29.871-27.949 c-16.158,1.44-28.982,16.289-28.644,33.165c0.018,0.882,0.092,1.744,0.179,2.601c-8.105,2.311-16.065,5.265-23.814,8.837 c-0.368-0.752-0.75-1.501-1.188-2.228c-8.372-13.895-26.366-17.307-40.191-7.622c-13.824,9.686-18.244,28.801-9.872,42.696 c0.429,0.712,0.899,1.377,1.376,2.034c-6.122,6.123-11.856,12.771-17.154,19.903c-0.685-0.43-1.38-0.85-2.114-1.222 c-14.163-7.191-31.956-0.588-39.742,14.747c-7.786,15.335-2.617,33.596,11.546,40.787c0.734,0.373,1.483,0.685,2.234,0.985 c-2.631,8.486-4.615,17.037-5.946,25.593c-0.812,0.003-1.627,0.016-2.453,0.089c-16.158,1.441-28.983,16.289-28.645,33.166 c0.338,16.877,13.712,29.389,29.87,27.949c0.844-0.075,1.674-0.208,2.499-0.355c1.688,8.363,4,16.533,6.918,24.44 c-0.743,0.434-1.483,0.884-2.205,1.39c-13.824,9.685-18.244,28.801-9.872,42.696c8.372,13.895,26.366,17.307,40.19,7.623 c0.708-0.497,1.375-1.033,2.033-1.577c5.461,6.036,11.449,11.63,17.928,16.735c-0.455,0.747-0.901,1.503-1.304,2.298 c-7.786,15.335-2.617,33.596,11.546,40.787s31.956,0.588,39.742-14.747c0.403-0.794,0.751-1.601,1.085-2.409 c7.945,2.219,15.995,3.752,24.09,4.598c-0.05,0.853-0.09,1.707-0.073,2.572c0.339,16.875,13.712,29.389,29.87,27.949 c16.158-1.441,28.983-16.289,28.644-33.165c-0.017-0.882-0.091-1.744-0.179-2.601c8.105-2.31,16.066-5.265,23.813-8.837 c0.368,0.752,0.751,1.501,1.188,2.226c8.372,13.895,26.366,17.308,40.19,7.622c13.825-9.686,18.244-28.801,9.872-42.697 c-0.429-0.711-0.899-1.377-1.376-2.034c6.122-6.122,11.855-12.771,17.153-19.902 C3006.588,1396.282,3007.283,1396.702,3008.017,1397.075z M2831.465,1399.315c-51.422-26.108-70.191-92.409-41.921-148.089 c28.27-55.679,92.872-79.651,144.294-53.543c51.422,26.108,70.19,92.409,41.921,148.089 C2947.489,1401.451,2882.887,1425.423,2831.465,1399.315z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109019533867519160890000018239271687174807715_",
    gradientUnits: "userSpaceOnUse",
    x1: 517.9685,
    y1: 3165.1587,
    x2: 1392.7457,
    y2: 3165.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109019533867519160890000018239271687174807715_)"
    },
    d: "M1392.746,3161.993v31.908 c0,8.169-4.198,14.917-9.745,15.654L885.18,3254.67c-3.694,0.513-7.407,0.418-11.078-0.221c-0.958-0.175-1.917-0.382-2.876-0.618 l-346.857-65.382c-3.689-0.954-6.4-5.78-6.4-11.384v-33.712l368.019-45.614l47.373-22.421l47.104,6.785l27.816-5.332 l63.574,18.503L1392.746,3161.993z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056406022505334685850000000422327172203448207_",
    gradientUnits: "userSpaceOnUse",
    x1: 1171.3092,
    y1: 3035.8472,
    x2: 1023.4589,
    y2: 3443.3677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5917,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000056406022505334685850000000422327172203448207_)"
    },
    d: "M1392.746,3161.993v31.908 c0,8.169-4.198,14.917-9.745,15.654l-497.799,45.113c-3.694,0.513-8.302,0.392-11.056-0.224v-171.884l59.237-7.244l47.093,6.786 l27.81-5.331l63.571,18.503L1392.746,3161.993z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078732938653264262730000016044319011421930921_",
    gradientUnits: "userSpaceOnUse",
    x1: 1018.5612,
    y1: 2977.7139,
    x2: 861.946,
    y2: 3409.3931
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5917,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078732938653264262730000016044319011421930921_)"
    },
    d: "M1008.281,3076.771l-490.312,65.083 l353.655,66.613c4.352,1.113,8.777,1.373,13.159,0.773l507.964-47.248L1008.281,3076.771z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035514168174576026250000012655960059808215690_",
    gradientUnits: "userSpaceOnUse",
    x1: 958.5223,
    y1: 2329.3569,
    x2: 926.6885,
    y2: 3365.9478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035514168174576026250000012655960059808215690_)"
    },
    d: "M1188.02,3135.558 c0,23.352-73.488,41.504-174.93,46.216c-25.609,1.179-52.983,1.507-81.385,0.851c-139.617-3.22-251.804-29.19-251.804-57.943 c0-0.652,0.077-2.068,0.193-2.066l-0.193-0.004l0.579-1.386c0.135-0.472,0.308-0.9,0.521-1.34l32.201-84.176l38.885-101.572 l54.457-142.356l41.678-108.97l51.846-135.497c6.487-16.965,18.507-27.51,31.501-27.51c1.767,0,3.495,0.18,5.204,0.569 c10.965,2.394,20.758,12.272,26.385,26.974l52.284,136.449l41.754,110.407l55.094,145.212v0.03l39.557,104.334v0.03l0.629,0.061 l32.943,84.79C1186.836,3130.924,1188.02,3133.234,1188.02,3135.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1152.474,3043.87c-31.789,10.622-82.605,18.271-143.44,21.116 c-24.519,1.154-50.457,1.527-77.482,1.013c-93.807-1.783-175.14-13.852-218.427-30.269l38.923-101.582 c45.545,10.245,109.024,17.153,179.579,18.215c22.815,0.343,45.046,0.049,66.217-0.802 c44.552-1.763,83.834-6.039,114.781-12.113l39.219,104.33v0.03L1152.474,3043.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1057.669,2794.205c-24.264,2.621-50.936,4.403-79.233,5.207 c-15.161,0.451-30.778,0.599-46.731,0.443c-45.659-0.445-88.363-3.365-125.162-8.068l41.678-108.972 c26.085,2.059,54.178,3.236,83.484,3.406c10.352,0.06,20.554-0.001,30.567-0.212c18.37-0.344,36.174-1.08,53.169-2.212 L1057.669,2794.205z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145059201208806089830000010502673336986662805_",
    gradientUnits: "userSpaceOnUse",
    x1: 679.9,
    y1: 2851.3811,
    x2: 1013.9746,
    y2: 2851.3811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000145059201208806089830000010502673336986662805_)"
    },
    d: "M1013.09,3181.774 c-25.609,1.179-52.983,1.507-81.385,0.851c-139.617-3.22-251.804-29.19-251.804-57.943c0-0.652,0.077-2.068,0.193-2.066 l-0.193-0.004l0.579-1.386c0.135-0.472,0.308-0.9,0.521-1.34l32.201-84.176l38.885-101.572l54.457-142.356l41.678-108.97 l51.846-135.497c6.487-16.965,18.507-27.51,31.501-27.51c1.767,0,3.495,0.18,5.204,0.569 c5.541,34.492,15.015,94.682,25.5,165.635c5.255,35.72,10.767,74.181,16.165,113.404c6.955,50.729,13.697,102.829,19.418,152.15 c4.675,40.42,8.662,78.982,11.485,113.425C1013.465,3114.847,1015.163,3156.089,1013.09,3181.774z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverDraftLimit);
export default __webpack_public_path__ + "static/media/over-draft-limit.171c7ec8c514a2425096228ffe5a4424.svg";
export { ForwardRef as ReactComponent };